import React, {useState} from "react";
import {pageAuthorizedByGroup} from "../fragments/PageAuthorization";
import {
	Alert,
	Breadcrumbs,
	FormControl,
	InputLabel,
	Link,
	MenuItem,
	Paper,
	Select,
	Stack,
	TextField,
	Typography
} from "@mui/material";
import {Link as RouterLink} from "react-router-dom";
import {graphQLServices} from "../../services/GraphQLServices";
import {UPDATE_UNDERWRITING_RESULT_BY_ORDER_IDS} from "./GraphQLQueries";
import {ProcessButton} from "../../components/common/input/ProcessButton";

const ADN_RES_OPTIONS: { label: string; value: string }[] = [
	{label: "Accepted", value: "V1"},
	{label: "Rejected", value: "V2"}
];

function UpdateUnderwritingResultPageContent() {
	const [orderIdsText, setOrderIdsText] = useState("");
	const [underwritingResult, setUnderwritingResult] = useState("");
	const [result, setResult] = useState<{ orderIds: string[] } | null>(null);

	const orderIds = orderIdsText
		.split(/[\n,;\s]+/)
		.map(id => id.trim())
		.filter(id => id.length > 0);

	const isValid = orderIds.length > 0 && underwritingResult !== "";

	async function handleUpdate() {
		setResult(null);
		const response = await graphQLServices.orderInputClient.mutate({
			mutation: UPDATE_UNDERWRITING_RESULT_BY_ORDER_IDS,
			variables: {
				orderIds,
				underwritingResult,
			},
		});

		const errors = response.errors;
		if (errors && errors.length > 0) throw errors[0];

		setResult(response.data?.updateUnderwritingResultByOrderIds);
	}

	return (
		<Stack spacing={2} style={{maxWidth: 800, margin: "0 auto", width: "100%"}}>
			<Breadcrumbs style={{margin: "5px"}}>
				<Link component={RouterLink} style={{color: "inherit", textDecoration: "unset"}} to="/orders">
					Orders
				</Link>
				<Typography color="text.primary">Update Underwriting Result</Typography>
			</Breadcrumbs>

			<Paper style={{padding: 20}}>
				<Stack spacing={3}>
					<Typography variant="h6">Update Underwriting Result by Order IDs</Typography>

					<TextField
						label="Order IDs"
						placeholder="Paste order IDs here (one per line, or separated by commas)"
						multiline
						minRows={6}
						maxRows={20}
						value={orderIdsText}
						onChange={e => setOrderIdsText(e.target.value)}
						fullWidth
					/>

					{orderIds.length > 0 && (
						<Typography variant="body2" color="text.secondary">
							{orderIds.length} order ID(s) detected
						</Typography>
					)}

					<FormControl fullWidth>
						<InputLabel>Underwriting Result</InputLabel>
						<Select
							value={underwritingResult}
							label="Underwriting Result"
							onChange={e => setUnderwritingResult(e.target.value)}
						>
							{ADN_RES_OPTIONS.map(opt => (
								<MenuItem key={opt.value} value={opt.value}>
									{opt.label}
								</MenuItem>
							))}
						</Select>
					</FormControl>

					<ProcessButton
						buttonProps={{disabled: !isValid}}
						defaultText={"Update"}
						inProgressText={"Updating..."}
						completedText={"Updated"}
						resetKeys={[orderIdsText, underwritingResult]}
						variant={"outlined"}
						onClick={handleUpdate}
					/>

					{result && (
						<Alert severity="success">
							Successfully updated {result.orderIds?.length ?? 0} order(s).
						</Alert>
					)}
				</Stack>
			</Paper>
		</Stack>
	);
}

export const UpdateUnderwritingResultPage = pageAuthorizedByGroup(UpdateUnderwritingResultPageContent, ["Admin", "Order"]);
